export const bestPrice = [
  {
    text: 'best-price-item-1'
  },
  {
    text: 'best-price-item-2'
  },
  {
    text: 'best-price-item-3'
  }
];

export const bestPriceRates = {
  defaultRate: 0.85,
  bookingComRate: 0.85,
  airbnbRate: 0.82,
  expediaRate: 0.82
};
